import React from 'react'

const TopCustomer = () => {
  return (
    <div className='dashboard-top-customer'>TopCustomer</div>
  )
}

export default TopCustomer